import React, { useEffect, useState } from "react";
import { ObjectValues } from "../../login";
import MobileEmulator from "../Preview/MobileEmulator";
import { useAppSelecter } from "../../../hooks/storeHooks";

function UpdatedQuestionPreviewWrapper({ questionEditData }: any) {
  const [selectedLang, setLang] = useState("english");

  const examsData = useAppSelecter((state: ObjectValues) => state.exams);
  const tags_list = examsData.tags_list ?? [];
  const formatPayload = (data: any, lang: string) => {
    const newObj: any = {};
    newObj["Question Tags"] =
      data.tag && data.tag.length > 0
        ? tags_list?.filter((item: { id: any }) =>
            data.tag.map((ss: any) => ss.id ?? ss).includes(item.id)
          )
        : [];

    newObj["Explanation"] =
      data.explanation?.translation?.length > 0
        ? data.explanation?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.explanation?.translation?.text ?? "";

    newObj["Option A"] =
      data.options[0]?.translation?.length > 0
        ? data.options[0]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[0]?.translation?.text ?? "";
    if (data.options[0]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option A" };
    }
    newObj["Option B"] =
      data.options[1]?.translation?.length > 0
        ? data.options[1]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[1]?.translation?.text ?? "";
    if (data.options[1]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option B" };
    }
    newObj["Option C"] =
      data.options[2]?.translation?.length > 0
        ? data.options[2]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[2]?.translation?.text ?? "";
    if (data.options[2]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option C" };
    }
    newObj["Option D"] =
      data.options[3]?.translation?.length > 0
        ? data.options[3]?.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data.options[3]?.translation?.text ?? "";
    if (data.options[3]?.is_correct) {
      newObj[`correct_answer`] = { label: "Option D" };
    }
    newObj["Question"] =
      Array.isArray(data.translation) && data.translation?.length > 0
        ? data.translation?.find(
            (item: { language: any }) => item.language === lang
          )?.text ?? ""
        : data?.translation?.text ?? "";

    return newObj;
  };
  console.log(questionEditData,"questionEditData")
  return (
    <MobileEmulator
      submittedData={formatPayload(
        Array.isArray(questionEditData) && questionEditData?.length > 0
          ? questionEditData.find(
              (s: { translation: { language: string } }) =>
                s.translation.language === selectedLang
            )
          : questionEditData,
        selectedLang
      )}
      languge={{
        languages:
          Array.isArray(questionEditData) && questionEditData?.length > 1
            ? ["english", "hindi"]
            :!Array.isArray(questionEditData)&& questionEditData?.languages_available?.includes(
                "hindi"
              )
                ? ["english", "hindi"]
                : ["english"],
        selectedLang: selectedLang,
        handleQuizLanguageToggled: (val) => {
          setLang(val);
        },
      }}
    />
  );
}

export default UpdatedQuestionPreviewWrapper;
